/*
 * Componente para el filtro de empresas
 */
import { isFunction } from "lodash";
import React, { Component } from "react";
import { AutoComplete } from "material-ui";
//import SearchIcon from "material-ui/svg-icons/action/search";

class SearchAutocompleteInput extends Component {
	constructor(props) {
		super(props);
    const {dataSource=[]} = props;
		this.state = {
      search: "",
      index: -1,
      dataSource,
      meta: {},
    };
	}

  componentWillReceiveProps(nextProps){
    const {dataSource=undefined, meta={}} = nextProps;
    if(dataSource!==undefined){
      this.setState({dataSource, meta});
    }
  }

  /*
   * run on everytime change in the input
   */
  handleUpdateInput = (searchText, dataSource, params) => {
    if(params.source === "change"){
      this.pushNotification(null, -1);
    }
  }

  /*
   * Run when the user select an item
   */
  handleNewRequest = (search, index) => {
    this.setState({search, index});
    // send notification to parent...
    this.pushNotification(search, index);
  };

  /*
   * send a notification to the parent component with the current autocomplete value
   */
  pushNotification(search, index){
    if (isFunction(this.props.onSelect)) {
			this.props.onSelect(search, index);
		}
  }

	render() {
		const {
      floatingLabelText = "",
      hintText = "",
      fullWidth = false,
      dataSourceConfig = undefined,
      openOnFocus = false,
      maxSearchResults = 10,
      textFieldStyle = undefined,
      style
    } = this.props;
    const {touched=false, error=false} = this.state.meta;
    return (
      <div style={style}>
        <AutoComplete
            hintText={hintText}
            floatingLabelText={floatingLabelText}
            openOnFocus={openOnFocus}
            textFieldStyle={textFieldStyle}
            fullWidth={fullWidth}

            onUpdateInput={this.handleUpdateInput}
            onNewRequest={this.handleNewRequest}

            errorText={touched && error}

            filter={AutoComplete.caseInsensitiveFilter}
            searchText={this.state.searchText}
            dataSource={this.state.dataSource}
            dataSourceConfig={dataSourceConfig}
            maxSearchResults={maxSearchResults}
        />
      </div>
    );
    /*
		return (
			<div style={{ position: "relative" }}>
				<TextField
					id="searchComponentInput"
					value={this.state.search}
					onChange={onChange}
					placeholder={placeholder}
					fullWidth
					style={{ textIndent: 30 }}
					inputStyle={{ color: "#616161" }}
				/>
				<SearchIcon
					style={{
						position: "absolute",
						left: 0,
						top: 15,
						width: 20,
						height: 20
					}}
					color={"#b1b1b1"}
				/>
			</div>
		);
    */
	}
}

export default SearchAutocompleteInput;



// WEBPACK FOOTER //
// ./src/components/SearchAutocompleteInput/SearchAutocompleteInput.js